import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, InnerHeading, MainHeading, SpanStyled, TitleHeading } from '../../../ui/Elements'
import { ArrowBtnBrown, ComMap, MBS, ProjectImg1, ProjectImg2, ProjectImg3, ProjectImg4, ProjectImg5, ProjectImg6, ProjectLogo1, ServicesBg, ServicesImg, ServicesImgAr, StatsBg1, StatsBg2, StatsBg3, StatsBg4, StripeBg, StripeBgAr, Vision, VisionAr, VisionBg, VisionBgAr } from '../../../ui/AllImages'

import { useTranslation } from 'react-i18next'
import { AboutBox } from '../../../ui/CustomElements'
import i18n from '../../../Languages/INEXT'
import { ProjectsDataList } from '../../projectData/Data'
import Clients from '../clients/Clients'
import { Animate } from 'react-simple-animate'

const Projects = () => {
    const { t } = useTranslation();
    const sectionRef = useRef(null);
                      const [isVisible, setIsVisible] = useState(false);
    
    const [mainImages, setMainImages] = useState(
    Object.fromEntries(ProjectsDataList.map((p) => [p.id, p.images[0]]))
  );

  const [imageIndexes, setImageIndexes] = useState(
    Object.fromEntries(ProjectsDataList.map((p) => [p.id, 0]))
  );

  // ✅ Manual click handler
  const handleThumbnailClick = (projectId, image, index) => {
    setMainImages((prev) => ({
      ...prev,
      [projectId]: image,
    }));
    setImageIndexes((prev) => ({
      ...prev,
      [projectId]: index,
    }));
  };
  // ✅ Auto-rotate every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setMainImages((prevImages) => {
        const updatedImages = { ...prevImages };
        const updatedIndexes = { ...imageIndexes };

        ProjectsDataList.forEach((project) => {
          const nextIndex =
            (updatedIndexes[project.id] + 1) % project.images.length;
          updatedImages[project.id] = project.images[nextIndex];
          updatedIndexes[project.id] = nextIndex;
        });

        setImageIndexes(updatedIndexes);
        return updatedImages;
      });
    }, 3000); // change every 5 seconds

    return () => clearInterval(interval);
  }, [imageIndexes]);
    useEffect(() => {
                        const observer = new IntersectionObserver(
                          ([entry]) => {
                            // When visible, set to true
                            if (entry.isIntersecting) {
                              setIsVisible(true);
                              observer.disconnect(); // run animation once
                            }
                          },
                          {
                            threshold: 0.2, // 20% of section visible triggers the animation
                          }
                        );
                    
                        if (sectionRef.current) {
                          observer.observe(sectionRef.current);
                        }
                    
                        return () => observer.disconnect();
                      }, []);
                        const start = { opacity: 0, transform: 'translateY(-40px)' };
                        const end = { opacity: 1, transform: 'translateY(0)' };
                        const start2 = { opacity: 0, transform: 'translateY(100px)' };
                        const end2 = { opacity: 1, transform: 'translateY(0)' };
    return (
        <Box  id='projects'>
            <ProjectsWrapper className='container-fluid secProjects common-space' ref={sectionRef}>
                <Container>
                    <Row className='projects-row'>
                        <Col md={12} className=''>
                        <Animate
                                                                            play={isVisible}
                                                                            duration={1}
                                                                            delay={.5}
                                                                            start={start}
                                                                            end={end}
                                                                        >
                            <MainHeading className='main-heading main-heading-projects mb-0' color="var(--white)">
                                {t('subBrands')}
                            </MainHeading>
                            </Animate>
                        </Col>
                        {ProjectsDataList.map((project) => (
                            <Col md={12} className='prrojectWrapperCol' key={project.id}>
                                <Animate
                                                                            play={isVisible}
                                                                            duration={1}
                                                                            delay={.5}
                                                                            start={start}
                                                                            end={end}
                                                                            >
                                <Box className="prrojectThumbnailWrapper d-flex">
                                    
                                    <Box className="prrojectThumbnailContainer">
                                        {project.images.map((img, index) => (
                                            <Box
                                            key={index}
                                            className="prrojectThumbnail"
                                            onClick={() => handleThumbnailClick(project.id, img)}
                                            style={{ cursor: "pointer" }}
                                            >
                                            <img src={img} alt="Project thumbnail" />
                                            </Box>
                                        ))}
                                    </Box>

                                    
                                    <Box className="prrojectImgContainer">
                                        <img src={mainImages[project.id]} alt="Project main" />
                                    </Box>
                                </Box>
                                </Animate>
                                <Box className="prrojectContentWrapper">
                                    <Animate
                                                                            play={isVisible}
                                                                            duration={1}
                                                                            delay={.5}
                                                                            start={start}
                                                                            end={end}
                                                                        >
                                    <Box className="projectContentProfile">
                                        <Box className='projectContentNumber'>
                                            {project.number}
                                        </Box>
                                        <Box className="projectContentLogo">
                                            {project.logoimg}
                                        </Box>
                                        <Box className="prrojectContentAbout">
                                            <InnerHeading className='sub-heading sub-heading-whyChoose' color="var(--secondaryColor)">
                                                {t(project.title)}
                                            </InnerHeading>
                                            <SpanStyled className='d-flex mb-1 prrojectContentName' color="var(--bg2)" sie="22px">
                                                {t(project.brandName)}
                                            </SpanStyled>
                                            <SpanStyled className='d-flex mb-0 prrojectContentName prrojectContentName2' color="var(--bg2)" sie="22px" family="var(--semiBold)">
                                                {t(project.tower)}
                                            </SpanStyled>
                                        </Box>
                                    </Box>
                                    </Animate>
                                    <Box className="prrojectContentAboutTxt">
                                        <Animate
                                                                            play={isVisible}
                                                                            duration={1}
                                                                            delay={1}
                                                                            start={start}
                                                                            end={end}
                                                                        >
                                        <SpanStyled className='mb-3 prrojectContentTxt' color="var(--bg2)" size="22px">
                                            {project.meaningFirst ? (
                                                t(project.meaningFirst)
                                            ) : (
                                                // Else show meaning / meaning1 + meaning2 logic
                                                i18n.language === "ar" ? (
                                                <>
                                                    {t(project.meaning1)}&nbsp;
                                                    <SpanStyled className='engReg' color="var(--bg2)" size="22px">Nexus</SpanStyled>&nbsp;
                                                    {t(project.meaning2)}
                                                </>
                                                ) : (
                                                <>
                                                    {t(project.meaning)}
                                                </>
                                                )
                                            )}
                                          
                                            
                                        </SpanStyled>
                                        <SpanStyled className='mb-0 prrojectContentTxt' color="var(--bg2)" size="22px">
                                            {project.alveraDescription ? (
                                                t(project.alveraDescription)
                                            ) : (
                                                // Else show meaning / meaning1 + meaning2 logic
                                                i18n.language === "ar" ? (
                                                <>
                                                    {t(project.nexiusDescription1)}&nbsp;
                                                    <SpanStyled className='engReg' color="var(--bg2)" size="22px">(Clusters)</SpanStyled>&nbsp;
                                                    {t(project.nexiusDescription2)}&nbsp;
                                                    <SpanStyled className='engReg' color="var(--bg2)" size="22px">2</SpanStyled>&nbsp;
                                                    {t(project.nexiusDescription3)}&nbsp;
                                                    <SpanStyled className='engReg' color="var(--bg2)" size="22px">6</SpanStyled>&nbsp;
                                                    {t(project.nexiusDescription4)}&nbsp;
                                                </>
                                                ) : (
                                                <>
                                                    {t(project.nexiusDescription1Eng)}
                                                </>
                                                )
                                            )}
                                        </SpanStyled>
</Animate>
                                    </Box>
                                </Box>
                            </Col>
                        ))}


                        
                    </Row>
                </Container>
                
            </ProjectsWrapper>
            <Clients />
        </Box>
    )
}
const ProjectsWrapper = styled.section`
    background-color: var(--themeColor);
    padding-top: 100px;
    padding-bottom: 30px;
    .main-heading-projects{
        text-align: center;
        /* padding-bottom: 15px; */
    }
    
    .prrojectWrapperCol{
        display: flex;
        align-items: center;
        border-bottom: 1px solid var(--bg2);
        padding-top: 95px;
        padding-bottom: 95px;
    }
    .prrojectWrapperCol:nth-child(3){
        border-bottom: none;
    }
    .prrojectThumbnail{
        border-radius: 0 32px 0 32px;
        overflow: hidden;
    }
    .prrojectThumbnailWrapper{
        display: flex;
        align-items: center;
        gap: 30px;
        max-width: 515px;
        min-width: 515px;
    }
    .prrojectContentWrapper{
        padding-left: 80px;
    }
    .prrojectThumbnailContainer{
        display: flex;
        flex-direction: column;
        gap: 18px;

        .prrojectThumbnail img{
            height: 171px;
            width: auto;
        }
    }
    .prrojectImgContainer{
        border-radius: 0 80px 0 80px;
        overflow: hidden;
    }
    .projectContentProfile{
        display: flex;
        width: 100%;
        gap: 24px;
        align-items: center;
        position: relative;
        z-index: 5;
    }
    .projectContentNumber{
        position: absolute;
        right: 0;
        font-family: var(--numberF);
        font-size: 175px;
        -webkit-text-fill-color: transparent;
        -webkit-text-stroke: 1px;
        color: var(--bg2);
        z-index: -1;
        opacity: .2;
        /* background-color: white; */
        /* text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000; */
    }
    .projectContentLogo{
        display: flex;
        min-width: 126px;
        max-width: 126px;
        height: 126px;
        background-color: var(--bg);
        border-radius: 32px 0 32px 0;
        align-items: center;
        justify-content: center;
        overflow: hidden;
    }
    .prrojectContentAboutTxt{
        margin-top: 40px;
    }
    body.rtl &{
        .prrojectThumbnail{
            border-radius: 32px 0 32px 0;
        }
       .prrojectImgContainer{
            border-radius: 80px 0px 80px 0px;
        }
        .prrojectContentWrapper{
            padding-left: auto;
            padding-right: 80px;
        }
        .prrojectContentName{
            font-size: 22px !important;
        }
        .prrojectContentName2{
            font-size: 22px !important;
            font-family: var(--jannaBold)
        }
        .projectContentNumber{
            right: auto;
            left: 0;
        }
        
    }
    @media (max-width: 1199px) {
        .prrojectContentWrapper{
            padding-left: 30px;
        }
        .projectContentNumber{
            top: -200px;
        }
        body.rtl &{
            .prrojectContentWrapper{
                padding-right: 30px;
                padding-left: 0;
            }
            
        }
        
    }
    @media (max-width: 991px) {
        padding-top: 50px;
        .prrojectWrapperCol{
            flex-wrap: wrap;
            gap: 50px;
        }
        .prrojectContentWrapper{
            padding-left: 0;
            padding-right: 0;
        }
        .prrojectThumbnailWrapper {
            max-width: 100%;
            min-width: 100%;
            justify-content: center;
        }
        .prrojectWrapperCol{
            padding-top: 50px;
            padding-bottom: 50px;
        }
        .projectContentNumber{
            display: none;
        }
        body.rtl &{
            .prrojectContentWrapper{
                padding-right: 0;
                padding-left: 0;
            }
            .main-heading-projects{
                font-size: 45px;
            }
        }
        
    }
    @media (max-width: 767px) {
        
    }
    @media (max-width: 570px) {
        .prrojectThumbnailWrapper{
            flex-wrap: wrap;
        }
        .prrojectThumbnailContainer{
            width: 100%;
            flex-direction: row;
            gap: 10px;
            justify-content: center;
        }
        .projectContentProfile{
            flex-wrap: wrap;
            justify-content: center;
            & *{
                text-align: center;
                justify-content: center;
            }
        }
        .prrojectContentAboutTxt{
            text-align: center;
        }
        .prrojectContentAbout{
            width: 100%;
            
        }
    }
`
export default Projects
